/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, isObject } from 'lodash';

// Components
import ImagePicker from 'shared/ui/components/form-components/pickers/ImagePicker.vue';
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';
import HorizontalDivider from 'shared/ui/components/HorizontalDivider.vue';

const __vue_script__ = {
    name: 'ThemeAssetsManager',

    components: {
        ImagePicker,
        LoaderButton,
        HorizontalDivider
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        const { event } = this.params;
        const eventId = event._id;
        return {
            icon: this.$utils.assets.getThemeAsset(eventId, 'app-icon', true),
            saving: false,
            eventId,
            allowedExtensions: ['png'],
            preview: 'web'
        };
    },

    computed: {
        appIcon() {
            if (isObject(this.icon)) {
                return get(this.icon, '0.url');
            }

            return this.icon;
        }
    },

    async created() {
        try {
            const metadata = await this.$services.metadata.getMetadataForType(this.eventId, 'theme_asset');
            this.allowedExtensions = metadata._allowed_types;
        } catch (error) {
            console.error('[ThemeAssetsManager] Could not load proper metadata', error.message);
        }
    },

    methods: {
        async save() {
            try {
                this.saving = true;
                const result = await this.$services.event.uploadAppIcon(this.icon[0], this.eventId);
                console.debug('[ThemeAssetsManager] Upload successful', result);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('theme.graphics.messages.could_save_asset').toString(),
                    type: 'success',
                    duration: 5000
                });

            } catch (error) {
                console.error('[ThemeAssetsManager] Could not save asset', error.message);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('theme.graphics.messages.could_not_save_asset').toString(),
                    type: 'error',
                    duration: 5000
                });

            } finally {
                this.saving = false;
            }
        },

        async onRemove() {
            try {
                await this.$services.documents.deleteAttachment(this.eventId, 'theme', 'app-icon.png');
                console.debug('[ThemeAssetsManager] Asset removal successful');

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('theme.graphics.messages.could_remove_asset').toString(),
                    type: 'success',
                    duration: 5000
                });

            } catch (error) {
                console.error('[ThemeAssetsManager] Could not remove asset', error.message);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('theme.graphics.messages.could_not_delete_asset').toString(),
                    type: 'error',
                    duration: 5000
                });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme-assets-manager"},[_c('validation-observer',{ref:"form",staticClass:"main-form",attrs:{"tag":"form"}},[_c('image-picker',{staticClass:"app-icon",attrs:{"name":"icon","label":_vm.$t('theme.graphics.app_icon.label'),"hint":_vm.$t('theme.graphics.app_icon.hint', [_vm.allowedExtensions.map(function (e) { return e.toLocaleUpperCase(); }).join(', ')]),"tip":_vm.$t('theme.graphics.app_icon.tip'),"extensions":_vm.allowedExtensions,"multiple":false,"ratio":1,"size":Math.pow( 1024, 2 ),"width":512,"height":512},on:{"removed":_vm.onRemove},model:{value:(_vm.icon),callback:function ($$v) {_vm.icon=$$v},expression:"icon"}})],1),_c('div',{staticClass:"apps-preview"},[_c('section',{staticClass:"previews"},[_c('horizontal-divider',{staticClass:"large"}),_c('div',{staticClass:"buttons-toggler"},[_c('button',{staticClass:"btn",class:{'btn-primary-alt': _vm.preview === 'web'},attrs:{"type":"button"},on:{"click":function($event){_vm.preview = 'web'}}},[_vm._v(_vm._s(_vm.$t('theme.editor.previews.web')))]),_c('button',{staticClass:"btn",class:{'btn-primary-alt': _vm.preview === 'mobile'},attrs:{"type":"button"},on:{"click":function($event){_vm.preview = 'mobile'}}},[_vm._v(_vm._s(_vm.$t('theme.editor.previews.mobile')))])]),_c('div',{staticClass:"environments"},[(_vm.preview === 'web')?_c('svg',{attrs:{"viewBox":"0 0 672 420","fill":"none","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"clip-path":"url(#clip0_1164_25316)"}},[_c('rect',{attrs:{"width":"672","height":"420","rx":"8","fill":"white"}}),_c('rect',{attrs:{"width":"672","height":"26","transform":"translate(0 1)","fill":"#E3E6E8"}}),_c('path',{attrs:{"d":"M591.807 11.6704C591.807 11.5434 591.857 11.4235 591.947 11.334C592.132 11.1486 592.434 11.1486 592.62 11.334L597.139 15.8534L601.659 11.334C601.748 11.2438 601.868 11.1943 601.995 11.1943C602.122 11.1943 602.242 11.2438 602.331 11.334C602.422 11.4235 602.471 11.5434 602.471 11.6704C602.471 11.7974 602.422 11.9173 602.331 12.0068L597.812 16.5263C597.441 16.8969 596.838 16.8976 596.467 16.5269L591.947 12.0068C591.857 11.9173 591.807 11.7974 591.807 11.6704Z","fill":"white"}}),_c('rect',{attrs:{"x":"567","y":"8","width":"18","height":"12","rx":"1.86796","fill":"white"}}),_c('rect',{attrs:{"x":"65","y":"7","width":"83","height":"14","rx":"1.86796","fill":"white"}}),_c('rect',{attrs:{"x":"174","y":"10","width":"29","height":"7","rx":"2","fill":"white"}}),_c('rect',{attrs:{"x":"211","y":"10","width":"29","height":"7","rx":"2","fill":"white"}}),_c('rect',{attrs:{"x":"248","y":"10","width":"29","height":"7","rx":"2","fill":"white"}}),_c('rect',{attrs:{"x":"285","y":"10","width":"29","height":"7","rx":"2","fill":"white"}}),_c('rect',{attrs:{"x":"65","y":"51","width":"29","height":"7","rx":"2","fill":"#AAB3BB"}}),_c('path',{attrs:{"d":"M128.25 74.25H231C233.071 74.25 234.75 75.9289 234.75 78V134C234.75 136.071 233.071 137.75 231 137.75H128.25V74.25Z","fill":"white"}}),_c('rect',{attrs:{"x":"138","y":"84","width":"48","height":"12","rx":"1.86796","fill":"#F1F2F4"}}),_c('rect',{attrs:{"x":"138","y":"108","width":"87","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"138","y":"120","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"64","y":"74","width":"170","height":"64","rx":"4","stroke":"#E3E6E8","stroke-width":"0.5"}}),(_vm.appIcon)?_c('image',{attrs:{"width":"64","height":"64","x":"64","y":"74","href":_vm.appIcon,"clip-path":"url(#clip-1)"}}):_vm._e(),(!_vm.appIcon)?_c('rect',{attrs:{"width":"74","height":"64","x":"64","y":"74","rx":"3","stroke":"#E3E6E8","clip-path":"url(#clip-1)"}}):_vm._e(),_c('path',{attrs:{"d":"M314.25 74.25H417C419.071 74.25 420.75 75.9289 420.75 78V134C420.75 136.071 419.071 137.75 417 137.75H314.25V74.25Z","fill":"white"}}),_c('rect',{attrs:{"x":"324","y":"84","width":"48","height":"12","rx":"1.86796","fill":"#F1F2F4"}}),_c('rect',{attrs:{"x":"324","y":"108","width":"87","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"324","y":"120","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('path',{attrs:{"d":"M314.25 74.25H417C419.071 74.25 420.75 75.9289 420.75 78V134C420.75 136.071 419.071 137.75 417 137.75H314.25V74.25Z","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M251 78C251 75.7909 252.791 74 255 74H315V138H255C252.791 138 251 136.209 251 134V78Z","fill":"#F1F2F4"}}),_c('path',{attrs:{"d":"M500.25 74.25H603C605.071 74.25 606.75 75.9289 606.75 78V134C606.75 136.071 605.071 137.75 603 137.75H500.25V74.25Z","fill":"white"}}),_c('rect',{attrs:{"x":"510","y":"84","width":"48","height":"12","rx":"1.86796","fill":"#F1F2F4"}}),_c('rect',{attrs:{"x":"510","y":"108","width":"87","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"510","y":"120","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('path',{attrs:{"d":"M500.25 74.25H603C605.071 74.25 606.75 75.9289 606.75 78V134C606.75 136.071 605.071 137.75 603 137.75H500.25V74.25Z","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M437 78C437 75.7909 438.791 74 441 74H501V138H441C438.791 138 437 136.209 437 134V78Z","fill":"#F1F2F4"}}),_c('path',{attrs:{"d":"M128.25 154.25H231C233.071 154.25 234.75 155.929 234.75 158V214C234.75 216.071 233.071 217.75 231 217.75H128.25V154.25Z","fill":"white"}}),_c('rect',{attrs:{"x":"138","y":"164","width":"48","height":"12","rx":"1.86796","fill":"#F1F2F4"}}),_c('rect',{attrs:{"x":"138","y":"188","width":"87","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"138","y":"200","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('path',{attrs:{"d":"M128.25 154.25H231C233.071 154.25 234.75 155.929 234.75 158V214C234.75 216.071 233.071 217.75 231 217.75H128.25V154.25Z","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M65 158C65 155.791 66.7909 154 69 154H129V218H69C66.7909 218 65 216.209 65 214V158Z","fill":"#F1F2F4"}}),_c('path',{attrs:{"d":"M314.25 154.25H417C419.071 154.25 420.75 155.929 420.75 158V214C420.75 216.071 419.071 217.75 417 217.75H314.25V154.25Z","fill":"white"}}),_c('rect',{attrs:{"x":"324","y":"164","width":"48","height":"12","rx":"1.86796","fill":"#F1F2F4"}}),_c('rect',{attrs:{"x":"324","y":"188","width":"87","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"324","y":"200","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('path',{attrs:{"d":"M314.25 154.25H417C419.071 154.25 420.75 155.929 420.75 158V214C420.75 216.071 419.071 217.75 417 217.75H314.25V154.25Z","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M251 158C251 155.791 252.791 154 255 154H315V218H255C252.791 218 251 216.209 251 214V158Z","fill":"#F1F2F4"}}),_c('path',{attrs:{"d":"M500.25 154.25H603C605.071 154.25 606.75 155.929 606.75 158V214C606.75 216.071 605.071 217.75 603 217.75H500.25V154.25Z","fill":"white"}}),_c('rect',{attrs:{"x":"510","y":"164","width":"48","height":"12","rx":"1.86796","fill":"#F1F2F4"}}),_c('rect',{attrs:{"x":"510","y":"188","width":"87","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"510","y":"200","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('path',{attrs:{"d":"M500.25 154.25H603C605.071 154.25 606.75 155.929 606.75 158V214C606.75 216.071 605.071 217.75 603 217.75H500.25V154.25Z","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M437 158C437 155.791 438.791 154 441 154H501V218H441C438.791 218 437 216.209 437 214V158Z","fill":"#F1F2F4"}}),_c('rect',{attrs:{"x":"65","y":"250","width":"29","height":"7","rx":"2","fill":"#AAB3BB"}}),_c('path',{attrs:{"d":"M128.25 273.25H231C233.071 273.25 234.75 274.929 234.75 277V333C234.75 335.071 233.071 336.75 231 336.75H128.25V273.25Z","fill":"white"}}),_c('rect',{attrs:{"x":"138","y":"283","width":"48","height":"12","rx":"1.86796","fill":"#F1F2F4"}}),_c('rect',{attrs:{"x":"138","y":"307","width":"87","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"138","y":"319","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('path',{attrs:{"d":"M128.25 273.25H231C233.071 273.25 234.75 274.929 234.75 277V333C234.75 335.071 233.071 336.75 231 336.75H128.25V273.25Z","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M65 277C65 274.791 66.7909 273 69 273H129V337H69C66.7909 337 65 335.209 65 333V277Z","fill":"#F1F2F4"}}),_c('path',{attrs:{"d":"M314.25 273.25H417C419.071 273.25 420.75 274.929 420.75 277V333C420.75 335.071 419.071 336.75 417 336.75H314.25V273.25Z","fill":"white"}}),_c('rect',{attrs:{"x":"324","y":"283","width":"48","height":"12","rx":"1.86796","fill":"#F1F2F4"}}),_c('rect',{attrs:{"x":"324","y":"307","width":"87","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"324","y":"319","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('path',{attrs:{"d":"M314.25 273.25H417C419.071 273.25 420.75 274.929 420.75 277V333C420.75 335.071 419.071 336.75 417 336.75H314.25V273.25Z","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M251 277C251 274.791 252.791 273 255 273H315V337H255C252.791 337 251 335.209 251 333V277Z","fill":"#F1F2F4"}}),_c('rect',{attrs:{"x":"65","y":"369","width":"29","height":"7","rx":"2","fill":"#AAB3BB"}}),_c('path',{attrs:{"d":"M128.25 392.25H231C233.071 392.25 234.75 393.929 234.75 396V452C234.75 454.071 233.071 455.75 231 455.75H128.25V392.25Z","fill":"white"}}),_c('rect',{attrs:{"x":"138","y":"402","width":"48","height":"12","rx":"1.86796","fill":"#F1F2F4"}}),_c('path',{attrs:{"d":"M128.25 392.25H231C233.071 392.25 234.75 393.929 234.75 396V452C234.75 454.071 233.071 455.75 231 455.75H128.25V392.25Z","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M65 396C65 393.791 66.7909 392 69 392H129V456H69C66.7909 456 65 454.209 65 452V396Z","fill":"#F1F2F4"}}),_c('path',{attrs:{"d":"M314.25 392.25H417C419.071 392.25 420.75 393.929 420.75 396V452C420.75 454.071 419.071 455.75 417 455.75H314.25V392.25Z","fill":"white"}}),_c('rect',{attrs:{"x":"324","y":"402","width":"48","height":"12","rx":"1.86796","fill":"#F1F2F4"}}),_c('path',{attrs:{"d":"M314.25 392.25H417C419.071 392.25 420.75 393.929 420.75 396V452C420.75 454.071 419.071 455.75 417 455.75H314.25V392.25Z","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M251 396C251 393.791 252.791 392 255 392H315V456H255C252.791 456 251 454.209 251 452V396Z","fill":"#F1F2F4"}}),_c('path',{attrs:{"d":"M500.25 392.25H603C605.071 392.25 606.75 393.929 606.75 396V452C606.75 454.071 605.071 455.75 603 455.75H500.25V392.25Z","fill":"white"}}),_c('rect',{attrs:{"x":"510","y":"402","width":"48","height":"12","rx":"1.86796","fill":"#F1F2F4"}}),_c('path',{attrs:{"d":"M500.25 392.25H603C605.071 392.25 606.75 393.929 606.75 396V452C606.75 454.071 605.071 455.75 603 455.75H500.25V392.25Z","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M437 396C437 393.791 438.791 392 441 392H501V456H441C438.791 456 437 454.209 437 452V396Z","fill":"#F1F2F4"}})]),_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"671","height":"419","rx":"7.5","stroke":"#E3E6E8"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1164_25316"}},[_c('rect',{attrs:{"width":"672","height":"420","rx":"8","fill":"white"}})]),_c('clipPath',{attrs:{"id":"clip-1"}},[_c('rect',{attrs:{"height":"64","width":"72","x":"64","y":"74","rx":"4","fill":"none"}})])])]):_vm._e(),(_vm.preview === 'mobile')?_c('svg',{attrs:{"width":"232","height":"450","viewBox":"0 0 232 450","fill":"none","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"clip-path":"url(#clip0_1164_26113)"}},[_c('rect',{attrs:{"width":"232","height":"450","rx":"8","fill":"white"}}),_c('rect',{attrs:{"x":"12","y":"90","width":"40","height":"16","rx":"4","fill":"#AAB3BB"}}),_c('rect',{attrs:{"x":"64","y":"90","width":"40","height":"16","rx":"4","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"116","y":"90","width":"40","height":"16","rx":"4","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"168","y":"90","width":"40","height":"16","rx":"4","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"220","y":"90","width":"40","height":"16","rx":"4","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"156","y":"16","width":"16","height":"16","rx":"4","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"180","y":"16","width":"16","height":"16","rx":"4","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"204","y":"16","width":"16","height":"16","rx":"4","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"12","y":"44","width":"72","height":"22","rx":"4","fill":"#E3E6E8"}}),(_vm.appIcon)?_c('image',{attrs:{"width":"56","height":"56","x":"12","y":"138","href":_vm.appIcon,"clip-path":"url(#clip-1)"}}):_vm._e(),(!_vm.appIcon)?_c('rect',{attrs:{"width":"56","height":"56","x":"12","y":"138","rx":"3","stroke":"#E3E6E8","clip-path":"url(#clip-1)"}}):_vm._e(),_c('rect',{attrs:{"x":"78","y":"148","width":"71","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"164","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"176","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"12.25","y":"138.25","width":"207.5","height":"55.5","rx":"3.75","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M12 204.25C12 203.007 13.0074 202 14.25 202H65.75C66.9926 202 68 203.007 68 204.25V255.75C68 256.993 66.9926 258 65.75 258H14.25C13.0074 258 12 256.993 12 255.75V204.25Z","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"212","width":"71","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"228","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"240","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"12.25","y":"202.25","width":"207.5","height":"55.5","rx":"3.75","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M12 268.25C12 267.007 13.0074 266 14.25 266H65.75C66.9926 266 68 267.007 68 268.25V319.75C68 320.993 66.9926 322 65.75 322H14.25C13.0074 322 12 320.993 12 319.75V268.25Z","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"276","width":"71","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"292","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"304","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"12.25","y":"266.25","width":"207.5","height":"55.5","rx":"3.75","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M12 332.25C12 331.007 13.0074 330 14.25 330H65.75C66.9926 330 68 331.007 68 332.25V383.75C68 384.993 66.9926 386 65.75 386H14.25C13.0074 386 12 384.993 12 383.75V332.25Z","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"340","width":"71","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"356","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"368","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"12.25","y":"330.25","width":"207.5","height":"55.5","rx":"3.75","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M12 396.25C12 395.007 13.0074 394 14.25 394H65.75C66.9926 394 68 395.007 68 396.25V447.75C68 448.993 66.9926 450 65.75 450H14.25C13.0074 450 12 448.993 12 447.75V396.25Z","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"404","width":"71","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"420","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"78","y":"432","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"12.25","y":"394.25","width":"207.5","height":"55.5","rx":"3.75","stroke":"#E3E6E8","stroke-width":"0.5"}}),_c('rect',{attrs:{"x":"12","y":"122","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('path',{attrs:{"d":"M18.406 28C18.5644 28 18.7141 27.9443 18.8258 27.8429C19.057 27.6343 19.057 27.2943 18.8258 27.085L13.1868 22L18.8258 16.9143C18.9382 16.8136 19 16.6786 19 16.5357C19 16.3929 18.9382 16.2579 18.8258 16.1571C18.7141 16.0557 18.5644 16 18.406 16C18.2476 16 18.0979 16.0557 17.9863 16.1571L12.3473 21.2429C11.8848 21.66 11.884 22.3393 12.3465 22.7564L17.9863 27.8429C18.0979 27.9443 18.2476 28 18.406 28Z","fill":"#2D3339"}})]),_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"231","height":"449","rx":"7.5","stroke":"#E3E6E8"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1164_26113"}},[_c('rect',{attrs:{"width":"232","height":"450","rx":"8","fill":"white"}})]),_c('clipPath',{attrs:{"id":"clip-1"}},[_c('rect',{attrs:{"height":"56","width":"60","x":"12","y":"138","rx":"3","fill":"none"}})])])]):_vm._e()])],1)]),_c('secondary-toolbar',[_c('loader-button',{staticClass:"primary",attrs:{"disabled":_vm.saving,"status":_vm.saving},on:{"click":function($event){return _vm.save()}}},[_vm._v(_vm._s(_vm.$t('general.save')))])],1)],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ThemeAssetsManager.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__